export enum TABLE_VARIANTS {
    INCLUSION = 'inclusion',
    ENGAGEMENT = 'engagement',
    BESPOKE = 'bespoke',
}

export enum FILTER_OPTIONS {
    OVER_TIME = 'results-over-time',
}
